<template>
    <div>
        <b-field v-for="payment in payments" :key="payment.id" class="mb-0">
            <div @click="handlePaymentClick(payment)" :class="getPaymentClass(payment)" class="custom-radio-container">
                <div class="columns is-mobile is-vcentered p-3">
                    <div class="column is-narrow">
                        <div class="custom-radio-circle">
                            <b-icon v-if="isSelected(payment)" class="selected" icon="check-circle"
                                size="is-small"></b-icon>
                            <b-tooltip v-else-if="getTooltipContent(payment)" position="is-right" class="disabled"
                                type="is-light" multilined>
                                <b-icon icon="alert-circle" size="is-small"></b-icon>
                                <template v-slot:content style="background-color: white;">
                                    <p class="is-size-7">{{ getTooltipContent(payment) }}</p>
                                </template>
                            </b-tooltip>
                            <b-icon v-else icon="radiobox-blank" size="is-small"></b-icon>
                        </div>
                    </div>
                    <div class="column">
                        <p class="is-size-6 has-text-weight-bold card-name">{{ formatDisplayName(payment) }}</p>
                        <p class="is-size-6 has-text-grey-light">
                            <span>{{ payment.brand }} •••• {{ payment.last4 }} |
                                <span :class="{ 'has-text-danger': !payment.validExpiration }">
                                    Exp: {{ payment.expirationMonth }}/{{ payment.expirationYear }}
                                </span>
                            </span>
                        </p>
                        <p class="is-size-6 has-text-grey-light" v-if="!payment.isSelectable">Unavailable for use</p>
                        <p class="is-size-7 is-underlined" v-if="expiredPersonalCard(payment)">Update Card</p>
                    </div>
                </div>
            </div>
        </b-field>
    </div>
</template>

<script>
import UpdateCardModal from "../CreditCardEntry/UpdateCardModal.vue";
export default {
    name: "PaymentMethodSelectBox",
    props: {
        payments: {
            type: Array,
            required: true
        },
        selectedPayment: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            internalSelectedPayment: this.selectedPayment
        };
    },
    watch: {
        selectedPayment(newVal) {
            this.internalSelectedPayment = newVal; // Sync prop with internal data
        }
    },
    methods: {
        handlePaymentClick(payment) {
            if (!payment.validExpiration && payment.recordType !== "Corporate Ghost Card") {
                return this.openUpdateCardModal(payment);
            }

            if (payment.isSelectable) {
                this.selectPayment(payment);
            }

            return;
        },
        selectPayment(payment) {
            this.internalSelectedPayment = payment; // Update the local selection
            this.$emit('paymentSelected', payment); // Emit the selection to the parent
        },
        openUpdateCardModal(card) {

            this.$buefy.modal.open({
                parent: this,
                component: UpdateCardModal,
                hasModalCard: true,
                customClass: "",
                trapFocus: true,
                props: {
                    card: card
                }
            });
        },
        isSelected(payment) {
            return this.internalSelectedPayment &&
                this.internalSelectedPayment.id === payment.id &&
                this.internalSelectedPayment.validExpiration;
        },
        formatDisplayName(payment) {
            if (payment.recordType == "Corporate Ghost Card") {
                return "Corporate Ghost Card"
            }
            return payment.displayName
        },
        expiredPersonalCard(payment) {
            return !payment.validExpiration && payment.recordType !== "Corporate Ghost Card";
        }

    },
    computed: {
        getPaymentClass() {
            return (payment) => ({
                'selected-payment': this.isSelected(payment),
                'unselected-payment': !this.isSelected(payment),
                'is-disabled': !payment.isSelectable || !payment.validExpiration,
            });
        },
        getTooltipContent() {
            return (payment) => {
                if (!payment.validExpiration) return "Card is expired.";
                if (!payment.isSelectable) return "Card cannot be used for one or more trip segments.";
                return null;
            };
        }
    }

};
</script>

<style scoped lang="scss">
.selected-payment {
    background-color: #a4393a;
    padding: 10px;
    cursor: pointer;
    color: #ffffff;
}

.unselected-payment {
    background-color: #ffffff;
    padding: 10px;
    cursor: pointer;
    border-radius: 4px;
}

.custom-radio-container {
    display: flex;
    align-items: center;

    .column {
        padding: 0;
    }
}

.custom-radio-circle {
    display: flex;
    font-size: 1.2rem;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    position: relative;
    cursor: pointer;

    .disabled {
        cursor: not-allowed;
    }
}

.is-disabled {
    background: whitesmoke;
    cursor: not-allowed;
    .card-name{
        color: #a1a1a1;
        text-decoration: line-through;
    }
}

.tooltip-override {
    pointer-events: auto; // Enable interactions with the tag (for the tooltip)
}
</style>